var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var _a, _b;
import { add, remove } from "../slices/fileslice";
import { useDispatch } from "react-redux";
import React, { useEffect, useState } from "react";
import { useAppSelector } from "../store";
import { Button, ButtonGroup, Flex, Grid, Heading, HStack, IconButton, Image, Input, InputGroup, InputLeftElement, InputRightElement, Link, Spinner, Text, VStack } from "@chakra-ui/react";
import { Versions } from "./versions";
export const getFromMetadata = (asset, key) => {
    let data = null;
    if (typeof asset.metaData === "undefined") {
        return data;
    }
    for (let meta of asset.metaData) {
        if (meta.name === key) {
            data = meta.data;
        }
    }
    return data;
};
// @ts-ignore
const phraseConfig = (_b = (_a = window.reacard) === null || _a === void 0 ? void 0 : _a.phraseConfig) !== null && _b !== void 0 ? _b : { navigateTo: "", portalFolder: "", portalFiles: "" };
const isFolder = (test) => {
    return typeof test === "object" && test.type === "folder";
};
let lastTimeout;
export const Filebrowser = (props) => {
    const [folderId, setFolderId] = useState(null);
    const [folder, setFolder] = useState(null);
    const [folders, setFolders] = useState([]);
    const [files, setFiles] = useState([]);
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [loading, setLoading] = useState(false);
    const [query, setQuery] = useState("");
    const favorites = useAppSelector((state) => state.file.favorites);
    const dispatch = useDispatch();
    useEffect(() => {
        setFolderId(props.folderId);
        setBreadcrumbs([]);
    }, [props.folderId]);
    const splitChildren = (data) => {
        let folders = [];
        let files = [];
        data.forEach(child => {
            if (isFolder(child)) {
                folders.push(child);
                return;
            }
            if (child.type === 'image' || child.type === 'text' || child.type === 'document') {
                files.push(child);
            }
        });
        return { folders, files };
    };
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            if (query === "" || folderId === null) {
                return;
            }
            setLoading(true);
            const params = new URLSearchParams({ query, folderId: folderId.toString() });
            const response = yield fetch("/api/filebrowser/search?" + params.toString());
            const data = yield response.json();
            const { files, folders } = splitChildren(data);
            setFolders(folders);
            setFiles(files);
            setLoading(false);
        });
        if (lastTimeout) {
            clearTimeout(lastTimeout);
        }
        // @ts-ignore
        lastTimeout = setTimeout(() => {
            load();
        }, 500);
    }, [query, folderId]);
    useEffect(() => {
        const load = () => __awaiter(void 0, void 0, void 0, function* () {
            if (query !== "" || folderId === null) {
                return;
            }
            setLoading(true);
            const response = yield fetch("/api/filebrowser/" + folderId);
            const data = yield response.json();
            setFolder(data);
            if (typeof data.children === "undefined" || data.children.length === 0) {
                return;
            }
            const { files, folders } = splitChildren(data.children);
            setFolders(folders);
            setFiles(files);
            setLoading(false);
        });
        if (folderId !== null) {
            load();
        }
    }, [query, folderId]);
    const formatFileSize = (bytes) => {
        if (!bytes)
            return "";
        let result = '';
        if (bytes >= 1000000) {
            bytes = bytes * 0.000001;
            result = bytes.toFixed(2) + 'MB';
        }
        else {
            bytes = bytes * 0.001;
            result = bytes.toFixed(2) + 'KB';
        }
        return result;
    };
    const getFileIcon = (asset) => {
        let type = null;
        if (asset.url === "undefined") {
            return null;
        }
        let url = asset.url.toLowerCase();
        if (url.includes('.jpg') || url.includes('.png') || url.includes('.svg') || url.includes('.webp') || url.includes('.tif') || url.includes('.tiff') || url.includes('.gif')) {
            return require('../../assets/image-light.svg');
        }
        else if (url.includes('.pdf')) {
            return require('../../assets/file-pdf-light.svg');
        }
        else {
            return require('../../assets/file-light.svg');
        }
    };
    const getFolder = () => {
        let folderMarkup = [];
        folders.forEach(folder => {
            folderMarkup.push(React.createElement(Button, { variant: "reaSecondary", h: "auto", textAlign: "left", justifyContent: "flex-start", leftIcon: React.createElement(Image, { src: require('../../assets/folder-light.svg'), width: 10, height: 10 }), gap: 2, minHeight: "6rem", onClick: () => {
                    setFolderId(folder.id);
                    setBreadcrumbs([...breadcrumbs, { id: folder.id, title: folder.name }]);
                }, title: phraseConfig.navigateTo + ' ' + folder.name },
                React.createElement(Text, { noOfLines: 2, overflowWrap: "break-word", whiteSpace: "normal" }, folder.name)));
        });
        return folderMarkup;
    };
    const getFiles = () => {
        let filesMarkup = [];
        files.forEach(file => {
            const title = getFromMetadata(file, 'title') || file.name;
            const description = getFromMetadata(file, 'description');
            filesMarkup.push(React.createElement(Flex, { flexDirection: ["column", "row"], backgroundColor: "reaGray.100", p: 4, borderRadius: "md", alignItems: ["stretch", "center"], gap: 4 },
                React.createElement(Flex, { gap: 4, alignItems: "center", flex: 1 },
                    React.createElement(Image, { src: getFileIcon(file), width: 10, height: 10 }),
                    React.createElement(VStack, { flex: 1, alignItems: "flex-start" },
                        React.createElement(Text, { fontWeight: 200, color: "reaBlue.800", noOfLines: 1 }, title),
                        description &&
                            React.createElement(Text, { fontWeight: 200, color: "reaBlue.800", noOfLines: 2 }, description))),
                React.createElement(HStack, { alignItems: "center" },
                    React.createElement(Text, { fontWeight: 200, color: "reaBlue.800", flex: 1 }, formatFileSize(file.fileSize)),
                    React.createElement(Button, { title: "Download", as: Link, variant: "ghost", href: '/assets' + file.url, target: "_blank" },
                        React.createElement(Image, { src: require('../../assets/download-light.svg'), minW: 6, height: 6 })),
                    React.createElement(Button, { title: "Favorit", variant: "ghost", onClick: () => {
                            if (favorites.find(item => item.id === file.id)) {
                                dispatch(remove(file.id));
                                return;
                            }
                            dispatch(add(file));
                        } },
                        React.createElement(Image, { src: favorites.find(item => item.id === file.id) ?
                                require('../../assets/star-solid.svg')
                                :
                                    require('../../assets/star-light.svg'), minW: 6, height: 6 })),
                    React.createElement(Versions, { assetId: file.assetId }))));
        });
        return filesMarkup;
    };
    const getBreadcrumbsMarkup = () => {
        let breadcrumbElements = [];
        breadcrumbElements.push(React.createElement(Button, { key: "start", onClick: () => {
                setFolderId(props.folderId);
                setBreadcrumbs([]);
            } }, "Start"));
        breadcrumbs.forEach((breadcrumb, index) => {
            breadcrumbElements.push(React.createElement(Button, { key: breadcrumb.id, onClick: () => {
                    let newBreadcrumbs = breadcrumbs;
                    newBreadcrumbs.splice(index + 1);
                    setFolderId(breadcrumb.id);
                    setBreadcrumbs(newBreadcrumbs);
                } }, breadcrumb.title));
        });
        return breadcrumbElements;
    };
    const folderElements = getFolder();
    const filesElements = getFiles();
    const breadcrumbElements = getBreadcrumbsMarkup();
    return (React.createElement(Flex, { flexDirection: "column", gap: 8 },
        React.createElement(VStack, { w: "100%", alignItems: "stretch" },
            React.createElement(HStack, { flex: 1 },
                React.createElement(ButtonGroup, { display: 'flex', flexWrap: 'wrap', size: 'sm', isAttached: true, variant: 'outline' }, breadcrumbElements)),
            React.createElement(InputGroup, null,
                React.createElement(InputLeftElement, { pointerEvents: "none" },
                    React.createElement(Image, { src: require('../../assets/search-light.svg'), width: 5, height: 5 })),
                query.length > 0 &&
                    React.createElement(InputRightElement, null,
                        React.createElement(IconButton, { icon: React.createElement(Image, { src: require('../../assets/web_close.svg'), width: 10, height: 10 }), "aria-label": "Suche abbrechen", size: "sm", variant: "ghost", onClick: () => setQuery(""), mr: 2 })),
                React.createElement(Input, { placeholder: "Dateien durchsuchen...", value: query, onChange: event => setQuery(event.target.value) }))),
        query !== "" && React.createElement(Text, null,
            "Zeige Ergebnisse f\u00FCr ",
            React.createElement("em", null, query),
            breadcrumbs.length > 0 &&
                React.createElement(React.Fragment, null,
                    " im Ordner ",
                    React.createElement("em", null, folder === null || folder === void 0 ? void 0 : folder.name),
                    React.createElement("br", null),
                    React.createElement(Button, { onClick: () => {
                            setFolderId(props.folderId);
                            setBreadcrumbs([]);
                        } }, "Im gesamten Verzeichnis suchen"))),
        loading ?
            React.createElement(Flex, { justifyContent: "center", alignItems: "center" },
                React.createElement(Spinner, { color: "reaBlue.800", w: 20, h: 20 }))
            :
                React.createElement(React.Fragment, null,
                    folderElements.length > 0 ?
                        React.createElement(Heading, { color: "reaBlue.800" }, phraseConfig.portalFolder)
                        :
                            null,
                    React.createElement(Grid, { templateColumns: ['repeat(1, 1fr)', 'repeat(1, 1fr)', 'repeat(3, 1fr)'], gap: 4 }, folderElements),
                    filesElements.length > 0 ?
                        React.createElement(Heading, { color: "reaBlue.800" }, phraseConfig.portalFiles)
                        :
                            null,
                    React.createElement(VStack, { w: "100%", spacing: 4, alignItems: "stretch" }, filesElements))));
};
